import React, { useState } from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { FlexyIconButton, ModalContext } from '@europrocurement/flexy-components';
import { editIcon } from '@europrocurement/l2d-icons';
import { SousClientApi, useSociete, useTiersService } from '@europrocurement/l2d-domain';
import { PrescriberClientForm } from '@europrocurement/l2d-modules/modules/PrescriberClient';

interface HeaderTitleProps {
    clientOpereRaisonSociale: string;
    prescriberId?: number;
    sousClientId?: number;
    onSuccess?: () => void;
}

export const HeaderTitle: React.FunctionComponent<HeaderTitleProps> = function ({
    clientOpereRaisonSociale,
    prescriberId,
    sousClientId,
    onSuccess,
}) {
    const { modalActions } = React.useContext(ModalContext);
    const [titleHovered, setTitleHovered] = useState(false);
    const xIdSociete = useSociete();

    const handleCancel = () => {
        modalActions.close();
    };

    const handleSuccess = async () => {
        try {
            modalActions.close();
            onSuccess?.();
        } catch (error) {
            console.error('Erreur lors de la mise à jour:', error);
        }
    };

    const openPrescriberClientForm = (sousClient: SousClientApi) => {
        modalActions.call(
            <PrescriberClientForm
                onCancel={handleCancel}
                onSuccess={handleSuccess}
                sousClient={sousClient}
            />,
        );
    };
    const { sousClientsApi } = useTiersService();

    const editFolio = async () => {
        if (!sousClientId) return;
        const sousClient = await sousClientsApi.getTiersTiersItem({
            id: sousClientId as unknown as string,
            xIdSociete,
        });
        openPrescriberClientForm(sousClient?.data as SousClientApi);
    };

    const titleWrapperStyle = {
        display: 'flex',
        flexDirection: 'row',
        gap: '0 8px',
        alignItems: 'center',
        justifyContent: 'flex-start',
        marginBottom: '0',
    };

    const titleStyle = {
        overflow: 'hidden',
        textWrap: 'nowrap',
    };

    const prescriberIsClient = prescriberId !== undefined && prescriberId === sousClientId;
    const title = (
        <Typography
            variant="l2dh5"
            sx={titleStyle}
        >
            {clientOpereRaisonSociale}
        </Typography>
    );

    return (
        <Box sx={titleWrapperStyle}>
            <Box
                sx={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    minHeight: '24px',
                }}
                onMouseEnter={() => setTitleHovered(true)}
                onMouseLeave={() => setTitleHovered(false)}
            >
                {prescriberIsClient && (
                    <Tooltip title="Pour modifier le prescripteur, rendez vous sur sa fiche">
                        {title}
                    </Tooltip>
                )}
                {!prescriberIsClient && (
                    <>
                        {title}
                        <Box
                            sx={{
                                display: 'flex',
                                gap: '4px',
                                opacity: titleHovered ? 1 : 0,
                                transform: titleHovered ? 'translateX(0)' : 'translateX(-10px)',
                                transition: 'all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                            }}
                        >
                            <FlexyIconButton
                                displayTooltip
                                icon={editIcon}
                                onClick={editFolio}
                                tooltipOverwriteProps={{
                                    title: 'Éditer la société opérée',
                                }}
                                iconOverwriteProps={{
                                    size: '2xs',
                                    sx: {
                                        '&:hover': {
                                            color: 'primary.main',
                                        },
                                    },
                                }}
                            />
                        </Box>
                    </>
                )}
            </Box>
        </Box>
    );
};
